__turbopack_context__.v({
  "action": "PurchasePhonesPlan-module-scss-module__UnNrna__action",
  "description": "PurchasePhonesPlan-module-scss-module__UnNrna__description",
  "is-selected": "PurchasePhonesPlan-module-scss-module__UnNrna__is-selected",
  "lead": "PurchasePhonesPlan-module-scss-module__UnNrna__lead",
  "learn-more": "PurchasePhonesPlan-module-scss-module__UnNrna__learn-more",
  "pick-button": "PurchasePhonesPlan-module-scss-module__UnNrna__pick-button",
  "price": "PurchasePhonesPlan-module-scss-module__UnNrna__price",
  "pricing": "PurchasePhonesPlan-module-scss-module__UnNrna__pricing",
  "pricing-toggle": "PurchasePhonesPlan-module-scss-module__UnNrna__pricing-toggle",
  "wrapper": "PurchasePhonesPlan-module-scss-module__UnNrna__wrapper",
});
